import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import showServiceEditorReducer from './slices/ServiceEditorSlice';
import selectedCategoryReducer from './slices/selectedCategorySlice';
import menuReducer from './slices/menuSlice';
import categoryToUpdateReducer from './slices/categoryToUpdateSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    menu: menuReducer,
    selectedCategory: selectedCategoryReducer,
    serviceEditor: showServiceEditorReducer,
    categoryToUpdate: categoryToUpdateReducer,
    auth: authReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
